module.exports = __webpack_public_path__ + "static/media/slide-8.b116fd23.png";